import { render } from "./UploadTable.vue?vue&type=template&id=5cd25247"
import script from "./UploadTable.vue?vue&type=script&lang=js"
export * from "./UploadTable.vue?vue&type=script&lang=js"

import exportComponent from "C:\\NicolPC\\VueWork2026\\Axxo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__